import React, { useEffect } from "react";
import { useLocation } from "@reach/router";
import { getPageData } from '@/data/pageData';
// import { LayersIcon } from "@/components/icons/icons";
// import { MessageSquareText, Landmark, MessageCircleQuestion } from "lucide-react";
// import FeatureCard from "@/components/cards/FeatureCard";
// import VideoPlayer from "@/components/utility/VideoPlayer";
import FWNavBar from "@/components/navbar/FullWidthNavBar";
import InLineNavBar from "@/components/navbar/InLineNavBar";
import config from '@/utils/config';
import ScrollRevealWrapper from "@/components/utility/ScrollRevealWrapper";
import { Link } from "gatsby";
import { MousePointerClick } from "lucide-react";

const Header = () => {
  const location = useLocation();
  const { backgroundImage, heading, description } = getPageData(location.pathname);
  const isHomepage = location.pathname === '/';

  useEffect(() => {
    const fwNavbar = document.getElementById("fw-navbar");
    const ilNavbar = document.getElementById("il-navbar");

    if (fwNavbar) {
      document.body.classList.add("fw-navbar");
    } else if (ilNavbar) {
      document.body.classList.add("il-navbar");
    }

    return () => {
      document.body.classList.remove("fw-navbar");
      document.body.classList.remove("il-navbar");
    };
  }, []);

  return (
    <>
      <header
        className="relative text-white"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gray-900 opacity-40"></div>
          {config.inlineNavbar ? <InLineNavBar /> : <FWNavBar />}

          <ScrollRevealWrapper>
            {isHomepage ? (
              <section className="relative z-10  py-40 lg:py-60">
                <div className="container mx-auto px-6 space-y-8">
                  <h1 className="text-center">Transforming Care Across Oceans</h1>
                  <div className="flex justify-center">
                    <Link
                      to="#mailing-list"
                      className="bg-c4 hover:bg-c5 text-white px-6 py-2 rounded-full inline-flex items-center gap-2 transition duration-300 text-lg lg:text-2xl font-semibold"
                    >
                      <MousePointerClick strokeWidth={1.5} size={50} />
                      <span>Join the mailing list</span>
                    </Link>
                  </div>


                </div>
              </section>
              ) : (
                <section className="relative z-10 py-20">
                <div className="container mx-auto gap-12 px-6">
                  <div className="space-y-6">
                    <h1 className="text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl">
                      {heading}
                    </h1>
                    <p className="text-white" dangerouslySetInnerHTML={{ __html: description }} />
                  </div>
                </div>
              </section>
            )}
          </ScrollRevealWrapper>

      </header>
    </>
  );
}

export default Header;
